import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterSection = styled("footer")`
  background: #061b3f;
  color: #d9e6f8;
  padding: 4rem 0 1.75rem;
`;

export const FooterGrid = styled("div")`
  display: grid;
  grid-template-columns:
    minmax(230px, 1.05fr) minmax(250px, 1.2fr) minmax(130px, 0.62fr)
    minmax(250px, 1.05fr);
  gap: clamp(1.75rem, 3.4vw, 3.5rem);
  align-items: start;

  @media screen and (max-width: 1050px) {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    column-gap: 3rem;
    row-gap: 2.5rem;
  }

  @media screen and (max-width: 680px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

export const FooterBrand = styled("div")`
  align-self: start;

  img {
    display: block;
    object-fit: contain;
    background: #fff;
    border-radius: 8px;
    margin-bottom: 1.25rem;
  }

  p {
    max-width: 420px;
    margin: 0;
    color: #b9c9df;
    font-size: 1rem;
    line-height: 1.7;
  }

  @media screen and (max-width: 1050px) and (min-width: 681px) {
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: 150px minmax(0, 520px);
    gap: 1.5rem;
    align-items: center;

    img {
      margin-bottom: 0;
    }
  }

  @media screen and (max-width: 680px) {
    img {
      margin-bottom: 1rem;
    }
  }
`;

export const FooterColumns = styled("div")`
  display: contents;
`;

export const FooterColumn = styled("div")`
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const FooterTitle = styled("h2")`
  min-height: 1.25rem;
  margin: 0 0 1rem;
  color: #fff;
  font-size: 1rem;
  letter-spacing: 0;
`;

export const FooterLink = styled(Link)`
  display: block;
  width: max-content;
  max-width: 100%;
  margin-bottom: 0.7rem;
  color: #b9c9df;
  font-weight: 700;

  &:hover {
    color: #fff;
  }
`;

export const ContactBlock = styled("div")`
  display: grid;
  gap: 0.9rem;
  max-width: 360px;
  width: 100%;
`;

export const PrimaryContact = styled("a")`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  min-height: 46px;
  width: max-content;
  min-width: 164px;
  padding: 0 1.15rem;
  border-radius: 8px;
  background: #56d4b0;
  color: #061b3f;
  font-weight: 900;

  svg {
    font-size: 1.2rem;
  }

  &:hover {
    color: #061b3f;
    background: #7ee5c8;
  }
`;

export const ContactLine = styled("a")`
  display: flex;
  align-items: center;
  gap: 0.65rem;
  width: fit-content;
  max-width: 100%;
  color: #b9c9df;
  font-weight: 700;

  svg {
    flex: 0 0 auto;
    color: #56d4b0;
  }

  &:hover {
    color: #fff;
  }
`;

export const ContactText = styled("span")`
  min-width: 0;
  overflow-wrap: anywhere;
  line-height: 1.4;
`;

export const ContactActions = styled("div")`
  display: flex;
  flex-wrap: wrap;
  gap: 0.9rem;
  padding-top: 0.25rem;

  a {
    color: #fff;
    font-size: 0.92rem;
    font-weight: 900;
    border-bottom: 1px solid rgba(86, 212, 176, 0.65);
  }

  a:hover {
    color: #56d4b0;
  }
`;

export const MutedText = styled("p")`
  display: flex;
  gap: 0.7rem;
  align-items: flex-start;
  max-width: 330px;
  margin: 0 0 1.25rem;
  color: #b9c9df;
  font-size: 0.98rem;
  line-height: 1.7;

  svg {
    color: #56d4b0;
    margin-top: 0.25rem;
  }
`;

export const LanguageSwitchContainer = styled("div")`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.7rem;
  margin-top: auto;
`;

export const LanguageSwitch = styled("button")`
  min-height: 38px;
  padding: 0 0.9rem;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
  cursor: pointer;
  font-weight: 800;

  &:hover {
    border-color: rgba(86, 212, 176, 0.7);
  }
`;

export const MapFrame = styled("iframe")`
  width: 100%;
  height: 260px;
  margin-top: 3rem;
  border: 0;
  border-radius: 8px;
  filter: grayscale(0.18) saturate(0.9);
`;

export const FooterBottom = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1.25rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: #8fa5c4;
  font-size: 0.9rem;

  @media screen and (max-width: 680px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
